import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilCorrienteHESP() {
  const [corrienteCampo4, setCorrienteCampo4] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteCampo3, setCorrienteCampo3] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteCampo2, setCorrienteCampo2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [corrienteCampo1, setCorrienteCampo1] = useState({
    value: [],
    fecha: [],
    estado: [],
  });



  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 40,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);
    populateCorrienteCampo4(data);
    populateCorrienteCampo3(data);
    populateCorrienteCampo2(data);
    populateCorrienteCampo1(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCorrienteCampo4(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Campo 4 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteCampo4({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteCampo3(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Campo 3 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteCampo3({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteCampo2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Campo 2 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteCampo2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteCampo1(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Corriente Campo 1 HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCorrienteCampo1({
      fecha: arrFechas,
      value: arrValues,
    });
  }


 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Corriente HESP"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Corriente Campo 4 HESP --------------------------------------- */}
            <Chart.Line
              name="Corriente Campo 4 HESP"
              data={corrienteCampo4.value}
              yAxis={0}
            />
            {/** -------------------------------- Corriente Campo 3 HESP --------------------------------------- */}
            <Chart.Line
              name="Corriente Campo 3 HESP"
              data={corrienteCampo3.value}
              yAxis={0}
            />
            {/** -------------------------------- Corriente Campo 2 HESP --------------------------------------- */}
            <Chart.Line
              name="Corriente Campo 2 HESP"
              data={corrienteCampo2.value}
              yAxis={0}
            />
            {/** -------------------------------- Corriente Campo 1 HESP --------------------------------------- */}
            <Chart.Line
              name="Corriente Campo 1 HESP"
              data={corrienteCampo1.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={corrienteCampo4.fecha} />

            <Chart.YAxis
              labelSuffix=" mA"
              title="Corriente, mA"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=""
              title=""
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
